module.exports = __webpack_public_path__ + "img/bdo.af11936a.png";